import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RequestService } from '@shared/services/request/request.service';
import { IPeriod, ICountry } from '@shared/interfaces';
import { IChannel, IElementsResponse } from '@main/interfaces';

@Injectable()
export class ReportApiService {
    constructor(private requestService: RequestService) {}

    getChannels(entitiesIdsPairs?: Record<string, string>): Observable<IChannel[]> {
        return this.requestService
            .dataset<IElementsResponse<IChannel>>({
                datasetName: 'channels',
                entitiesIdsPairs,
                labelArea: 'base_service',
            })
            .pipe(map((result) => result.elements));
    }

    getPeriods(entitiesIdsPairs?: Record<string, string>): Observable<IPeriod[]> {
        return this.requestService
            .dataset<IElementsResponse<IPeriod>>({
                datasetName: 'periods',
                entitiesIdsPairs,
                labelArea: 'base_service',
            })
            .pipe(map((result) => result.elements));
    }

    getCountries(entitiesIdsPairs?: Record<string, string>): Observable<ICountry[]> {
        /*
        if (entityItemsIds && !entityItemsIds.length) {
            return of([]);
        }
*/
        return this.requestService
            .dataset<IElementsResponse<ICountry>>({
                datasetName: 'countries',
                entitiesIdsPairs,
                labelArea: 'base_service',
            })
            .pipe(map((result) => result.elements.filter((v) => Boolean(v.id))));
    }
}
